import _ from "lodash"
import { useEffect, useState } from "react"

export function useAutoLogout(timeGapNum: number) {
  const [idle, setIdle] = useState(false)

  useEffect(() => {
    let idleTimer: number | null = null

    const resetTimer = () => {
      if (idleTimer) {
        clearTimeout(idleTimer)
      }
      idleTimer = setTimeout(() => {
        // 规定时间内用户无任何操作（鼠标/键盘），则自动登出
        setIdle(true)
      }, timeGapNum) as unknown as number
    }

    const handleActivity = _.throttle(() => {
      if (idle) {
        setIdle(false)
      }
      resetTimer()
    }, 2000)

    // 设置初始计时器
    resetTimer()

    // 添加事件监听器以检测用户活动
    window.addEventListener("mousemove", handleActivity)
    window.addEventListener("wheel", handleActivity)
    window.addEventListener("mousedown", handleActivity)
    window.addEventListener("keydown", handleActivity)

    // 清除所有监听器和定时器
    return () => {
      if (idleTimer) {
        clearTimeout(idleTimer)
      }

      window.removeEventListener("mousemove", handleActivity)
      window.removeEventListener("wheel", handleActivity)
      window.removeEventListener("mousedown", handleActivity)
      window.removeEventListener("keydown", handleActivity)
    }
  }, [idle, timeGapNum])

  return idle
}
